import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AccountService } from '@app/_services';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const accountService = inject(AccountService);
    return next(req).pipe(catchError(err => {
        const isRefreshTokenRequest = err.url?.includes('/accounts/refresh-token');

        if ([401, 403].includes(err.status) || (err.status === 400 && isRefreshTokenRequest)) {
            // auto logout if 401, 403 or 400 refresh-token response returned from api
            if (accountService.accountValue) {
                accountService.logout();
            }
        }

        let error = (err && err.error && err.error.message) || err.statusText;

        if (err.status === 0) {
            error = 'Unable to connect to the server. Please check your internet connection.';
        } else if ([502, 503, 504].includes(err.status)) {
            error = 'The service is temporarily unavailable. Please try again in a few moments.';
        }

        // Suppress noise for expected refresh token failures
        if (!(isRefreshTokenRequest && (err.status === 400 || err.status === 401))) {
            console.error(err);
        }

        return throwError(() => error);
    }));
};